export default __webpack_public_path__ + "static/media/road.868c0357.jpg";